import models from 'public/models.json';
export default {
  name: 'ElCol',

  props: {
    _span: {
      type: Number,
      default: 24
    },
    _tag: {
      type: String,
      default: 'div'
    },
    _offset: Number,
    _pull: Number,
    _push: Number,
    xs: [Number, Object],
    sm: [Number, Object],
    md: [Number, Object],
    lg: [Number, Object],
    xl: [Number, Object]
  },

  computed: {
    gutter() {
      let parent = this.$parent;
      while (parent && parent.$options.componentName !== 'ElRow') {
        parent = parent.$parent;
      }
      return parent ? parent._gutter : 0;
    }
  },
  render(h) {
    const that = this;
    let classList = [];
    let style = {};

    if (this.gutter) {
      style.paddingLeft = this.gutter / 2 + 'px';
      style.paddingRight = style.paddingLeft;
    }

    ['_span', '_offset', '_pull', '_push'].forEach(prop => {
      if (this[prop] || this[prop] === 0) {
        classList.push(
          prop !== '_span'
            ? `el-col-${prop}-${this[prop]}`
            : `el-col-${this[prop]}`
        );
      }
    });

    ['xs', 'sm', 'md', 'lg', 'xl'].forEach(size => {
      if (typeof this[size] === 'number') {
        classList.push(`el-col-${size}-${this[size]}`);
      } else if (typeof this[size] === 'object') {
        let props = this[size];
        Object.keys(props).forEach(prop => {
          classList.push(
            prop !== '_span'
              ? `el-col-${size}-${prop}-${props[prop]}`
              : `el-col-${size}-${props[prop]}`
          );
        });
      }
    });
    ////console.log('标签' + this._tag, '方法', this.$listeners);
    const model = models[that._tag] ? models[that._tag] : {
      event: 'input',
      prop: 'value'
    };
    return h(this._tag, {
      class: ['el-col', classList],
      style,
      props: {
        ...that.$attrs,
        ...that.$props,
        [model.prop]: that.value
      },
      on: {
        ...that.$listeners,
        [model.event]: function (value) {
          that.$emit('input', value)
        }
      },
    }, this.$slots.default);
  },
  mounted() {
    const self = this;
    self.$emit('mounted', self);
  }
};



// WEBPACK FOOTER //
// ./src/components/public/element-secondary/c/src/col.js